import IconInfo from "@endya-conformite/ui-kit/src/assets/icons/info-circle.svg?react";
import { Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import classNames from "classnames";
import styles from "./CardWithBadge.module.scss";

type CardWithBadgeProps = {
  label?: string;
  hideIcon?: boolean;
  icon?: JSX.Element;
  badgeVariant?: "info" | "warning" | "error" | "success" | "primary";
  hasBadge?: boolean;
  description?: string;
  classNameChildren?: string;
  fullWidthBadge?: boolean;
} & Parameters<typeof Card>[0];

export function CardWithBadge({
  label,
  hideIcon = false,
  icon,
  description,
  badgeVariant = "info",
  hasBadge,
  fullWidthBadge,
  children,
  ...props
}: CardWithBadgeProps) {
  return (
    <Card
      {...props}
      className={classNames(styles.card, props.className, {
        [styles.badge]: hasBadge,
        [styles[`badge__${badgeVariant}`]]: hasBadge,
        [styles.fullWidthBadge]: fullWidthBadge,
      })}
    >
      {hasBadge && (
        <div
          data-variant={badgeVariant}
          className={classNames(styles.title, {
            [styles.fullWidth]: fullWidthBadge,
          })}
        >
          {hideIcon || (icon ||  <IconInfo />)} {label}
        </div>
      )}

      <div className={classNames(styles.children, props.classNameChildren)}>
        {children}
      </div>
    </Card>
  );
}
